import styled from "styled-components";
import { Divider } from "../../../Divider";
import { colors } from "../../../../styles/variables";

export const StyledForm = styled.form`
  width: 100%;
`;

export const StyledFormRow = styled.div`
  display: flex;
  gap: 10px;
`;

export const StyledLabel = styled.label`
  display: flex;
  color: ${colors.gray900};
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  align-items: center;
  width: 100%;
`;

export const StyledButtonWrapper = styled.div`
  margin: 40px 0;
`;

export const StyledFields = styled.div`
  margin: 40px 0 20px;
`;

export const StyledColumn = styled.div`
  flex-grow: 1;
`;

export const StyledBirthdayRow = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`;

export const StyledDivider = styled(Divider)`
  margin: 16px 0;
`;

export const StyledError = styled.span`
  font-size: 14px;
  line-height: 1.3;
  color: ${colors.red};
  margin-top: -5px;
  display: block;
  margin-bottom: 10px;
  text-align: center;
`;
